import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { MasterAdminInvitePageService } from '@/pages/MasterAdminInvite/services';

const MODULE_NAME = 'profile.machines.states.reinviteOrg';

const getSrv = () => {
  return vappContainer.get<MasterAdminInvitePageService>(
    MasterAdminInvitePageService.displayName
  );
};

export const reInviteUser = async (context: any, event: any) => {
  const currentState = 'RE_INVITE';
  const method = 'reInvite';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent?.getReInviteUser(event?.payload);
      if (content) {
        return resolve({
          key: 'RE_INVITE_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Reset password failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RE_INVITE_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'RE_INVITE_FAILED',
        value: _msg,
      });
    }
  });
};
